export default __webpack_public_path__ + "static/media/description-hero.f707c325.jpg";